import React from 'react';
import { Modal } from 'react-bootstrap';

const CancelModal = ({ show, handleClose, handleConfirm, handleCut }) => {
  return (
    <Modal show={show} onHide={handleCut} centered>
      <Modal.Body>
        <div className="comman-small-pop">
          <div className="center-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M53.3958 0H6.60423C2.97042 0 0 2.97042 0 6.60423V53.3958C0 57.0296 2.97042 60 6.60423 60H53.3958C57.0296 60 60 57.0296 60 53.3958V6.60423C60 2.97042 57.0296 0 53.3958 0ZM19.9437 28.3225C17.7127 30.2704 16.2211 30.4817 14.9366 29.1423C13.6901 27.8408 13.9352 26.3535 15.8789 24.207C15.5958 23.9916 15.262 23.8014 15.0085 23.5394C13.8761 22.3648 13.8634 20.6239 14.9577 19.5127C16.0775 18.3761 17.8394 18.3761 19.0394 19.538C19.293 19.7831 19.5 20.0789 19.7155 20.3408C22.0437 18.4268 23.4169 18.2155 24.6887 19.5084C25.9521 20.793 25.7324 22.2042 23.8352 24.4394C24.1225 24.6887 24.4437 24.9254 24.7099 25.2127C25.7831 26.3662 25.7577 28.1028 24.6718 29.1887C23.5986 30.262 21.9 30.3084 20.7507 29.269C20.4549 29.0028 20.2268 28.6563 19.9437 28.3225ZM37.707 40.4155C36.6084 41.6239 34.893 41.6535 33.5704 40.4873C31.3521 38.5268 28.6394 38.5225 26.4423 40.4831C25.1282 41.6535 23.4127 41.6282 22.3056 40.4282C21.2155 39.2451 21.3254 37.4958 22.5887 36.3C24.6845 34.3141 27.1944 33.3592 30.0211 33.3296C32.8944 33.393 35.3577 34.3437 37.4197 36.2873C38.6789 37.4789 38.793 39.2197 37.707 40.4155ZM45.807 27.431C45.6845 28.069 45.3761 28.7662 44.9366 29.2268C43.7113 30.507 42.2915 30.2324 40.1662 28.4155C39.8662 28.7028 39.5704 29.007 39.2535 29.2817C38.0831 30.3042 36.393 30.2577 35.3282 29.1845C34.2423 28.0859 34.2211 26.3577 35.2986 25.2085C35.5563 24.9338 35.8648 24.7014 36.3592 24.262C35.9408 23.9577 35.5732 23.7634 35.3028 23.4803C34.2169 22.331 34.238 20.5901 35.3197 19.5042C36.4056 18.4099 38.1296 18.3718 39.2958 19.4493C39.5915 19.7197 39.8113 20.0704 40.069 20.3873C42.169 18.4394 43.6141 18.1944 44.9451 19.4197C46.3014 20.6704 46.107 22.1113 44.2437 24.3845C45.1394 25.2 46.0648 26.0746 45.807 27.431Z"
                fill="#151515"
              />
            </svg>
          </div>
          <h3>Are you sure about cancel<br />this booking?</h3>
          <p>You can always reschedule it.</p>
          <div className="comman-pop-action-double">
            <button className="btn-outline" onClick={handleConfirm}>
              Cancel Booking
            </button>
            <button className="btn-fill" onClick={handleClose}>
              Reschedule
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelModal;